import React from 'react';
import { motion } from 'framer-motion';

const OfferSection = () => {
  const handleCTAClick = () => {
    window.open('https://abdul.cc/awaaipay', '_blank');
  };

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="bg-white bg-opacity-95 backdrop-blur-lg rounded-2xl p-8 sm:p-12 text-center border-4 border-yellow-400 shadow-2xl"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mb-8">
            🎯 Special Launch Offer
          </h2>
          
          <div className="mb-8">
            <div className="flex items-center justify-center mb-4">
              <span className="text-red-500 text-2xl sm:text-3xl mr-3">❌</span>
              <span className="text-2xl sm:text-3xl text-gray-600 line-through">
                ₹4,997/month (₹59,964/year)
              </span>
            </div>
            
            <div className="flex items-center justify-center mb-6">
              <span className="text-green-500 text-2xl sm:text-3xl mr-3">✅</span>
              <span className="text-4xl sm:text-5xl md:text-6xl font-bold text-green-600">
                Pay ₹4,997 → Get 12 Months FREE!
              </span>
            </div>
            
            <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-black rounded-xl p-4 mb-4">
              <p className="text-xl sm:text-2xl font-bold">
                🔥 Pay for 1 Month & Get Full Year Access!
              </p>
            </div>
            
            <p className="text-lg sm:text-xl text-gray-600 font-semibold mb-2">
              *(Less than ₹14/day! Cheaper than your morning tea ☕)*
            </p>
            
            <p className="text-base sm:text-lg text-gray-500 font-medium">
              *Inclusive of GST - No Hidden Charges
            </p>
          </div>
          
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <button
              onClick={handleCTAClick}
              className="bg-green-500 hover:bg-green-400 text-white text-2xl sm:text-3xl font-bold py-6 px-12 rounded-full shadow-2xl transform transition-all duration-300 mb-6"
            >
              Claim My Spot Now 🚀
            </button>
          </motion.div>
          
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="bg-red-600 text-white rounded-xl p-4 sm:p-6 animate-pulse"
          >
            <p className="text-xl sm:text-2xl font-bold">
              🚨 Only First 15 Tamil Members | ⏰ Offer Ends 30th Sept 2025 @ 10PM IST
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default OfferSection;